import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { ref: "inner" }

import { onMounted, ref } from "vue";
import PopupWindow from "@/core/popup/components/PopupWindow.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProcessLogDialog',
  props: {
    dialog: { type: Boolean },
    logBuffer: {},
    moved: { type: Boolean },
    flowName: {},
    flowVersion: {}
  },
  emits: ["close", "downloadLogsAsText"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const bufferValue = ref([]);

onMounted(() => {
  if (props.logBuffer) {
    bufferValue.value = props.logBuffer;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PopupWindow, {
      dialog: _ctx.dialog,
      size: "sm",
      live: 0,
      fixed: false,
      moved: _ctx.moved,
      lazyLoad: false,
      "fixed-height": false,
      onDownloadLogsAsText: _cache[0] || (_cache[0] = ($event: any) => (emit('downloadLogsAsText'))),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
    }, {
      "header-label": _withCtx(() => [
        _createTextVNode(_toDisplayString(props.flowName != null
            ? `${props.flowName}${
                props.flowVersion != null ? ` (v.${props.flowVersion})` : ""
              }`
            : "Logs"), 1)
      ]),
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bufferValue.value, (item, index) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "text-sm-start",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ], 512)
      ]),
      _: 1
    }, 8, ["dialog", "moved"])
  ]))
}
}

})